import { lazy } from "react";

/**
 * Route-level code splitting: every page component is loaded on demand so the
 * initial bundle stays small. Both `I18nRouter` and `MonoRouter` import their
 * page components from here to avoid duplicating the lazy declarations.
 *
 * Route guards and layout shells (ProtectedRoute, AppShell, ...) stay eagerly
 * imported in the routers since they are needed to render any route.
 */

export const Home = lazy(() => import("../../pages/Home/Home"));
export const Pricing = lazy(() => import("../../pages/Pricing/Pricing"));
export const Login = lazy(() => import("../../pages/Login/Login"));
export const Register = lazy(() => import("../../pages/Register/Register"));
export const ForgotPassword = lazy(
  () => import("../../pages/ForgotPassword/ForgotPassword"),
);
export const ResetPassword = lazy(
  () => import("../../pages/ResetPassword/ResetPassword"),
);
export const Onboarding = lazy(
  () => import("../../pages/Onboarding/Onboarding"),
);
export const OrganisationInvitation = lazy(
  () => import("../../pages/OrganisationInvitation/OrganisationInvitation"),
);
export const CookiePolicy = lazy(
  () => import("../../pages/CookiePolicy/CookiePolicy"),
);
export const TermsOfUses = lazy(
  () => import("../../pages/TermsOfUses/TermsOfUses"),
);
export const NotFound = lazy(() => import("../../pages/NotFound/NotFound"));

export const EventsList = lazy(
  () => import("../../pages/Events/EventsList/EventsList"),
);
export const NewEvent = lazy(
  () => import("../../pages/Events/NewEvent/NewEvent"),
);
export const EventDetail = lazy(
  () => import("../../pages/Events/EventDetail/EventDetail"),
);
export const Contracts = lazy(() => import("../../pages/Contracts/Contracts"));
export const ContractTemplates = lazy(
  () => import("../../pages/ContractTemplates/ContractTemplates"),
);
export const Profile = lazy(() => import("../../pages/Profile/Profile"));

export const SettingsLayout = lazy(
  () => import("../../pages/Settings/SettingsLayout/SettingsLayout"),
);
export const GeneralSettings = lazy(
  () => import("../../pages/Settings/GeneralSettings/GeneralSettings"),
);
export const MembersSettings = lazy(
  () => import("../../pages/Settings/MembersSettings/MembersSettings"),
);
export const InvitationsSettings = lazy(
  () => import("../../pages/Settings/InvitationsSettings/InvitationsSettings"),
);
export const ReferentialsSettings = lazy(
  () =>
    import("../../pages/Settings/ReferentialsSettings/ReferentialsSettings"),
);
export const FinanceSettings = lazy(
  () => import("../../pages/Settings/FinanceSettings/FinanceSettings"),
);
export const VolunteerLinkSettings = lazy(
  () =>
    import("../../pages/Settings/VolunteerLinkSettings/VolunteerLinkSettings"),
);

export const VolunteersList = lazy(
  () => import("../../pages/Volunteers/VolunteersList/VolunteersList"),
);
export const NewVolunteer = lazy(
  () => import("../../pages/Volunteers/NewVolunteer/NewVolunteer"),
);

export const VolunteerLogin = lazy(
  () => import("../../pages/VolunteerLogin/VolunteerLogin"),
);
export const VolunteerForgotPassword = lazy(
  () => import("../../pages/VolunteerForgotPassword/VolunteerForgotPassword"),
);
export const VolunteerResetPassword = lazy(
  () => import("../../pages/VolunteerResetPassword/VolunteerResetPassword"),
);
export const VolunteerSignup = lazy(
  () => import("../../pages/VolunteerSignup/VolunteerSignup"),
);
export const VolunteerDashboard = lazy(
  () => import("../../pages/VolunteerDashboard/VolunteerDashboard"),
);
export const VolunteerEventGuests = lazy(
  () => import("../../pages/VolunteerEventGuests/VolunteerEventGuests"),
);
export const PublicGuestList = lazy(
  () => import("../../pages/PublicGuestList/PublicGuestList"),
);
